export default __webpack_public_path__ + "static/media/unknown.87fbd0b9.png";